import axios from "axios";
import { resolveApiBaseUrl } from "@/utils/hostname";

function catalogUrl() {
  return `${resolveApiBaseUrl()}plans/catalog`;
}

function demoRequestUrl() {
  // Demo requests stay on the central/public API host.
  const configured = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api/";
  const base = configured.endsWith("/") ? configured : `${configured}/`;
  return `${base}demos/request`;
}

export default {
  getAll() {
    return axios.get(catalogUrl());
  },
  requestDemo(payload) {
    return axios.post(demoRequestUrl(), payload);
  },
};
